<template>
  <ab-flow-base-cmp :block="block" class="image-editor-cmp" :class="classesString" :style="imageStyles" />
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import {pathHelper} from "@/utils/pathHelper";
import {renderMixins} from "@/components/DiagramDesigner/Editor/components/renderMixins";

export default {
  mixins: [renderMixins],
  components: {AbFlowBaseCmp},
  inject: {
    designer: {
      default: false
    },
    canvas: {
      default: false
    },
    animation_frame: {
      default: 0
    }
  },
  props: ['block'],
  name: "ImageEditorCmp",
  data: () => ({
    upKey: 0,
    someVar: 1
  }),

  /**
   * Created
   */
  created() {
    this.designer.addListener?.(this.block.id, (data) => {
      this.eventListener(data)
    });
  },

  /**
   * Before unmount
   */
  beforeUnmount() {
    this.designer.removeListener?.(this.block.id);
  },

  methods: {
    /**
     * Event listener
     * @param data
     */
    eventListener() {
      // Update image
      this.upKey++
    }
  },

  computed: {

    /**
     * Get image styles
     */
    imageStyles() {
      const styles = {
        background: `url(${this.image_source}) no-repeat`
      }

      // Apply settings
      styles['background-size'] = this.block.properties?.fitting || 'cover'
      styles['background-position'] = this.block.properties?.position || 'center'

      // Return styles list
      return Object.assign(styles, this.stylesString);
    },

    /**
     * image source
     * @return {boolean|*|boolean}
     */
    image_source() {
      // Get value
      const value = this.getValue(this.block?.properties?.image);

      // Check for p3p source
      if(value?.source === 'p3p') {
        return this.wait('source', this.p3pNode.resourceUrl(value?.accessToken), "")
      }

      // Get path
      const path = pathHelper.assetPath(value?.source_url || value);

      // Modify path
      const url = path ? `${path}${path.includes('?') ? '&' : '?'}up=${this.upKey}` : undefined;

      // Return url
      return url ? url : require("@/assets/plugs/default-image.png");

    },
  }
}

</script>

<style lang="scss">

.image-editor-cmp {
  position: relative;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}

</style>
